<template>

  <v-container fluid>
    
    <!-- 추가/수정 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog" @keydown.esc="close" max-width="500px">
        <v-card class="dialog_round pa-10">
          <v-card-title>
            <span class="dialog_title">{{$t('sendpush_label1')}}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <label>{{$t('sendpush_label2')}}</label>
              </v-row>
              <v-row>
                <comdialog  :comname="PUSH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
              </v-row>
              <v-row>
                <eventdialog  :eventname="PUSH_EVENT_NAME" :comidx="PUSH_COM_IDX" @callback="eventsearchcb"></eventdialog>
              </v-row>
              <v-row>
                <optiondialog :optionname="PUSH_OPTION_NAME" :comidx="PUSH_COM_IDX" :eventidx="PUSH_EVENT_IDX" @callback="optionsearchcb"></optiondialog>
              </v-row>
              <v-row dense>
                <v-col md="12" sm="12" xs="12">
                <v-text-field outlined single-line v-model="editedItem.PUSHTITLE" :label="$t('sendpush_label3')" counter="20"></v-text-field>
                </v-col>
              </v-row>
              <v-row dense> 
                <v-textarea counter="50" v-model="editedItem.PUSHDESC" :label="$t('sendpush_label4')" value="" outlined :rules="[ v => (v.length <= 50) || $t('sendpush_label5') ]" ></v-textarea>
              </v-row>
              <v-row justify="center" class="mt-5">
                <v-btn class="dialog_cancel_btn mr-5" rounded large @click="close">{{$t("common_close")}}</v-btn>
                <v-btn rounded color="primary" @click="sendPush()">{{$t('eventinvit_label18')}}</v-btn>  
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>  
    </v-row>

    <v-row align="center">

      <v-col cols="12" md="2" sm="12" xs="12">
        <label class="menunamestyle">{{this.$session.get("MENUNAME")}}</label>
      </v-col>

      <v-spacer/>

      <!-- 검색어 -->
      <v-col cols="12" md="3" sm="12" xs="12">
        <v-text-field 
          dense single-line clearable
          @keyup.enter="search_run" 
          v-model="search_keyword" 
          :placeholder="$t('common_search_holder')"
          outlined height="43"
          color="#808080"
          class="ml-10"
          hide-details
          />
      </v-col>

      <v-col cols="6" md="1" sm="6" xs="6" class="pa-0" align="center">
        <v-btn style="width:94%" class="search_btn_freesize" outlined large @click="search_run">{{$t("common_search")}}</v-btn>
      </v-col>        
      <v-col cols="6" md="1" sm="6" xs="6" class="pa-0" align="center">
        <v-btn style="width:94%" class="search_btn_freesize" elevation="0" outlined large @click="newinsert">{{$t('eventinvit_label13')}}</v-btn>
      </v-col>
      
  </v-row>
  <v-row dense no-gutters>
    <label class="total_label">{{$t("common_total")}}</label><label class="total_label">{{totalcnt}}</label>
  </v-row>
    
  <v-row align="start">
    <v-col>
      <!-- 테이블 -->
      <v-data-table
        :headers="headers"
        :items="itemList"
        v-model="selected"
        :no-data-text="$t('common_nodata')"
        hide-default-footer
        
        class="datatablestyle"
        :items-per-page="pagerow"
        :search="search"  
        item-key="IDX"
        :loading="loading"
        >
        <template v-slot:header.COM_NAME>
          <a :class="sort_name=='COM_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('COM_NAME')">{{$t('sendpush_col1')}}</a>
        </template>
        <template v-slot:header.EVENT_NAME>
          <a :class="sort_name=='EVENT_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('EVENT_NAME')">{{$t('sendpush_col2')}}</a>
        </template>
        <template v-slot:header.OPTION_NAME>
          <label class="cheader_normal" >{{$t("sendpush_col3")}}</label>
        </template>
        <template v-slot:header.PUSHTITLE>
          <label class="cheader_normal" >{{$t("sendpush_col4")}}</label>
        </template>
        <template v-slot:header.PUSHCNT>
          <label class="cheader_normal" >{{$t("sendpush_col5")}}</label>
        </template>
        <template v-slot:header.PUSHSUCCESS>
          <label class="cheader_normal" >{{$t("sendpush_col6")}}</label>
        </template>
        <template v-slot:header.SENDDATE>
          <a :class="sort_name=='SENDDATE'?'cheader_sortselect':'cheader_sort'" @click="customsort('SENDDATE')">{{$t('sendpush_col7')}}</a>
        </template>
        <template v-slot:header.SEND_NAME>
          <a :class="sort_name=='SEND_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('SEND_NAME')">{{$t('sendpush_col8')}}</a>
        </template>

      </v-data-table>
    </v-col>
  </v-row>

  <!-- 하단 페이징 영역 -->
  <v-row align="start">
    <v-col cols="12" md="1"/>
    <v-col cols="12" md="2">
      <v-text-field
        v-model="search"
        append-icon="search"
        :label="$t('common_filter')"
        single-line
        hide-details
        outlined height="43"
        color="#808080"
        dense
        />
    </v-col>
    <v-col cols="12" md="6" class="d-flex justify-center">
      <v-btn v-if="bottompage > 10" icon  small @click="prev()"><v-icon dark>mdi-chevron-left</v-icon></v-btn>
      <span v-for="n in subpage" :key="n.id">
          <span v-if="page == bottompage-1+n">
              <v-btn color="red" icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
          <span v-else>
              <v-btn icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
      </span>
      <v-btn v-if="subpage == 10" icon small @click="next()" ><v-icon dark>mdi-chevron-right</v-icon></v-btn>
    </v-col>
    <v-col cols="12" md="2">
      <v-select
        v-model="pagerow"
        :items="pagerow_combo"
        item-text="NAME"      
        item-value="VALUE"
        :label="$t('common_rownum')"
        min-width="150px"
        outlined height="43"
        color="#808080"
        dense
        ></v-select>
    </v-col>
    <v-col cols="12" md="1"/>
  </v-row>

  
  

  </v-container>
</template>

<script>

export default {

    data: () => ({

      //필수 페이징 파라메터
      totalcnt : 0,       //전체 아이템 개수
      page : 0,
      maxpage : 0,        //전체 페이지 개수
      startpage : 1,      //시작 인덱스
      bottompage : 1,     //하단 페이징 번호의 시작점을 계산하기 위한 변수
      subpage : 1,       //하단 페이징 번호의 종료점을 계산하기 위한 변수
      loading : false,    //로딩 표시

      //CRUD 관련
      dialogTitle: '추가하기',   //다이얼로그 제목
      editedIndex: -1,          //-1이면 신규, -1보다 크면 업데이트
      dialog:false,
      defaultItem: {
          COM_IDX:'',
          PUSHTITLE:'',
          PUSHDESC:'',
      },
      editedItem: {
      },
      selected:[],              //테이블에 선택된 아이템 리스트

      //테이블 정의
      headers: [
        {text: '기업명', value: 'COM_NAME', sortable: false, align:'center'},
        {text: '행사명', value: 'EVENT_NAME', sortable: false, align:'center'},
        {text: '등록 카테고리', value: 'OPTION_NAME', sortable: false, align:'center'},
        {text: '제목', value: 'PUSHTITLE', sortable: false, align:'center'},
        {text: '발송', value: 'PUSHCNT', sortable: false, align:'center'},
        {text: '성공', value: 'PUSHSUCCESS', sortable: false, align:'center'},
        {text: '발송일시', value: 'SENDDATE', sortable: false, align:'center' },
        {text: '발송자', value: 'SEND_NAME', sortable: false, align:'center'}
      ],
      itemList: [],

      //검색 파라메터
      sort_name: 'REGDATE',
      sort_type: true,    //true : DESC, false: ASC

      search_keyword : '',
      search: '',         //필터링용 검색어

      //한 페이지 ROW 개수 설정
      pagerow : 20,       //한 페이지에 보여줄 row수
      pagerow_combo : [
          {NAME:'20', VALUE:20}
        , {NAME:'50', VALUE:50}
        , {NAME:'100', VALUE:100}
        , {NAME:'200', VALUE:200}
      ],    
        
      PUSH_COM_IDX: null,
      PUSH_COM_NAME: '',
      PUSH_EVENT_IDX: null,
      PUSH_EVENT_NAME: '',
      PUSH_OPTION_IDX: null,
      PUSH_OPTION_NAME: '',
      grade : 0,

    }),

    mounted(){
      
      if(this.$session.get("GRADE") < 10){
        this.$alert(this.$t("common_nograde"));
        this.$router.push("Login");
        return;
      }

      //this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
      //this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
      //this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
      //this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
      this.grade = this.$session.get("GRADE");

      if(this.$session.exists("ADMIN_IDX")){
        this.initpage();
      }else{
        //키값 없으면 로그인으로
        this.$router.push("Login");
      }
    },

    create(){
      
    },

    methods: {

      sendPush(){

        //푸시알림 발송
        if(this.PUSH_COM_IDX == null || this.PUSH_COM_IDX == undefined){
          this.$alert(this.$t('common_select_com'));
          return;
        } 
        if(this.PUSH_EVENT_IDX == null || this.PUSH_EVENT_IDX == undefined){
          this.$alert(this.$t('common_select_event'));
          return;
        }
        if(this.editedItem.PUSHTITLE == undefined || this.editedItem.PUSHTITLE.length < 1){
          this.$alert(this.$t('sendpush_msg1'));
          return;
        } 
        if(this.editedItem.PUSHTITLE.length > 20){
          this.$alert(this.$t('sendpush_msg2'));
          return;
        } 
        if(this.editedItem.PUSHDESC.length > 50){
          this.$alert(this.$t('sendpush_msg3'));
          return;
        } 
        this.$confirm(this.$t('sendpush_msg4'))
        .then(() => {
          this.save();
        });

      },

      //추가 저장
      async save () {
          
          //신규
          this.loading = true;
          this.$http.post(this.$host+'/api/SendPushInsert',{
                COM_IDX: this.PUSH_COM_IDX == null || this.PUSH_COM_IDX == undefined ? null : this.PUSH_COM_IDX
              , EVENT_IDX: this.PUSH_EVENT_IDX == null || this.PUSH_EVENT_IDX == undefined ? null : this.PUSH_EVENT_IDX
              , OPTION_IDX: this.PUSH_OPTION_IDX == null || this.PUSH_OPTION_IDX == undefined ? null : this.PUSH_OPTION_IDX
              , PUSHTITLE: escape(this.editedItem.PUSHTITLE)
              , PUSHDESC: escape(this.editedItem.PUSHDESC)
              , SENDIDX: this.$session.get("COM_IDX")
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }
                this.$alert(this.$t('sendpush_msg5')).then(()=>{
                  const p = this.page;
                  this.page = 0;
                  this.loadpage(p);
                });
      

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.$alert(this.$t('sendpush_msg6'));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t('sendpush_msg6'));
          });

          this.close()
      },      


      customsort(sortname){
        this.sort_name = sortname;
        this.sort_type = !this.sort_type;
        this.loadpage(this.page);
      },

      prev(){
          this.bottompage = this.bottompage - 10 >= 1 ? this.bottompage - 10 : 1;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage + this.subpage - 1; //이전을 누르면 가장 끝 번호 선택
          this.loadpage(temp_page);
      },
      next(){
          this.bottompage = this.bottompage + 10 <= this.maxpage ? this.bottompage + 10 : this.maxpage;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage;
          this.loadpage(temp_page);
      },

      makepaging(){
        var div1 = this.totalcnt / this.pagerow; 
        var div2 = this.totalcnt % this.pagerow;
        if(div2 == 0){  
            this.maxpage = parseInt(div1);    
        }else{
            this.maxpage = parseInt(div1+1);
        }
        if(this.bottompage == 1){
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
        }
      },

      loadpage(p){

          if(this.loading){
            return;
          }

          this.itemList.splice(0, this.itemList.length);   //데이터 초기화
          this.loading = true;
          this.page = p;

          this.$http.post(this.$host+'/api/SendPushList',{
                search_keyword: this.search_keyword == null || this.search_keyword == undefined ?  '' : escape(this.search_keyword)
              , sort_name:this.sort_name
              , sort_type: this.sort_type==true ? "DESC" : "ASC" 
              , page: this.page
              , pagerow: this.pagerow
              , LAN_CODE:this.$i18n.locale
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{

            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

                this.totalcnt = result.data.totalcnt;
                this.makepaging();
                const list = result.data.resultData;
                
                list.forEach(element => {
                    this.itemList.push(element); 
                });
                this.loading = false;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

      },

      initpage(){
        //첫페이지 로드
        this.loadpage(1);
      },      

      //다이얼로그 닫기
      close () {
        this.dialog     = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },


      //검색
      search_run(){
        this.loadpage(1);
      },
      

      //신규 추가
      newinsert(){
        this.dialogTitle = this.$t('common_insert_title');
        this.editedIndex  = -1;
        this.editedItem = Object.assign({}, this.defaultItem);
        this.dialog = true;
      },


      //추가 함수들
      changefiles(file) {
        this.$alert(JSON.stringify(file.files));
      },

      //base64 이미지 데이터를 파일로 변환
      dataURLtoFile(dataurl, fileName){
 
        var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), 
        n = bstr.length, 
        u8arr = new Uint8Array(n);
            
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        
        return new File([u8arr], fileName, {type:mime});

      },

      //검색조건 업체 설정
      eventsearchcb(val1){
        if(val1.NAME.length > 0){
          this.PUSH_EVENT_NAME = val1.NAME;
          this.PUSH_EVENT_IDX  = val1.IDX;
        }else{
          this.PUSH_EVENT_NAME = "";
          this.PUSH_EVENT_IDX  = null;
        }
        this.loadpage(1);                  
      },


      //업체 설정
      comsearchcb(val1){
        if(val1.NAME.length > 0){
          this.PUSH_COM_NAME = val1.NAME;
          this.PUSH_COM_IDX  = val1.IDX;
        }else{
          this.PUSH_COM_NAME = '';
          this.PUSH_COM_IDX  = null;
        }
        this.PUSH_EVENT_IDX  = null;
        this.PUSH_EVENT_NAME = '';
      },
      
      //행사옵션 선택 콜백
      optionsearchcb(val1){
        if(val1.NAME.length > 0){
          this.PUSH_OPTION_NAME  = val1.NAME;
          this.PUSH_OPTION_IDX  = val1.IDX;
        }else{
          this.PUSH_OPTION_NAME  = '';
          this.PUSH_OPTION_IDX   = null;
        }
      },

      // eslint-disable-next-line no-unused-vars
      comsearchclear(var2){
        this.PUSH_COM_IDX  = null;
        this.PUSH_COM_NAME = '';
        this.PUSH_EVENT_IDX  = null;
        this.PUSH_EVENT_NAME = '';
        this.PUSH_OPTION_NAME  = '';
        this.PUSH_OPTION_IDX   = null;
      },



    },
  
}
</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>


</style>